import { gql } from '@apollo/client';

export const GET_ALL_CONTEST_RESULTS= gql`
    query{
  getAllContestResults{
    _id
    ContestName
    ContestDate
  }
}
`;

export const GET_CURRENT_PRIZE_INFO= gql`
query{
  getCurrentPrizeInfo
}
`;

export const GET_ALL_CERTIFICATES= gql`
    query{
  getAllCertificates
}
`;

const GET_ALL_NEWS= gql`
    query{
  getAllNews{
    _id
    NewsDate
    Title
    Text
    TextForMain
  }
}
`;

export const GET_NEWS_INDEX= gql`
    query{
  getNewsIndex{
    _id
    NewsDate
    Title
    Text
    TextForMain
  }
}
`;

export const GET_CONTEST_INFO_BY_ID= gql`
    query($ContestID : String!){
  getContestByID(ContestID : $ContestID){
    _id
    ContestName
    ContestDate
    Itog
  }
}
`;

export const GET_CURRENT_CONTEST_TAG = gql`
    query($ContestName : String!){
  GetCurrentContestTag(ContestName : $ContestName){
        _id
    Info
  }
}
`;

export const MT7_REGISTRATION_CONTEST = gql`
mutation($email: String $password : String $TradingAccount : Int, $ContestName: String ){
  MT7RegistrationContest(email: $email, password : $password, TradingAccount : $TradingAccount, ContestName: $ContestName)
}`;

export const MT7_CREATE_CLIENT = gql`
mutation($email: String $name : String $surname : String $password : String, $ClientId : String, $agentTag : String)
{MT7CreateClient(email: $email, name : $name, surname : $surname, password : $password  ClientId : $ClientId agentTag : $agentTag)}`;